import React, { useState } from "react";
import { useSubmitSignedClaimForm } from "./workshopHooks";

const ClaimForm = ({ step, onClose, isDark, caseData }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);

  const accidentCaseNo = caseData?.accidentCaseNo || caseData?.id;
  const downloadUrl = caseData?.claimFormDraftDoc || step?.fileUrl || null;

  const [signedUrl, setSignedUrl] = useState(caseData?.claimFormSignedDoc || null);
  const uploaded = !!signedUrl;

  const { mutateAsync: submitSignedForm, isPending: loading } = useSubmitSignedClaimForm();

  const handleUpload = async () => {
    if (!file) return setError("Please select a filled form to upload");
    setError(null);
    try {
      const result = await submitSignedForm({ caseId: accidentCaseNo, file });setSignedUrl(result?.claimFormSignedDoc || result?.fileUrl || true);
    } catch (err) {
      setError(err.message || "Upload failed. Please try again.");
    }
  };

  return (
    <div
      className="cw-slideIn"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* 🔥 HEADER */}
      <div
        style={{
          padding: "22px 20px 18px",
          borderLeft: "4px solid #ec4899",
          background: isDark
            ? "linear-gradient(135deg, rgba(236,72,153,0.15), transparent)"
            : "linear-gradient(135deg, rgba(236,72,153,0.08), transparent)",
          borderBottom: isDark
            ? "1px solid rgba(255,255,255,0.05)"
            : "1px solid rgba(236,72,153,0.08)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 28, marginBottom: 6 }}>📑</div>
            <div
              className="cw-syne"
              style={{ fontSize: 17, fontWeight: 800, color: "#ec4899" }}
            >
              Claim Form
            </div>
          </div>

          {/* ❌ CLOSE */}
          <button
            onClick={onClose}
            style={{
              width: 36,
              height: 36,
              borderRadius: 12,
              cursor: "pointer",
              background: isDark
                ? "rgba(255,255,255,0.06)"
                : "rgba(99,102,241,0.08)",
              border: isDark
                ? "1px solid rgba(255,255,255,0.12)"
                : "1.5px solid rgba(99,102,241,0.15)",
              color: isDark ? "#fff" : "#6366f1",
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* 🔥 BODY */}
      <div style={{ padding: 20 }}>
        {uploaded && (
          <div
            style={{
              padding: 18,
              borderRadius: 16,
              background: isDark
                ? "rgba(34,197,94,0.15)"
                : "rgba(34,197,94,0.08)",
              border: "1px solid rgba(34,197,94,0.3)",
            }}
          >
           <div style={{ fontSize: 13, fontWeight: 700, color: "#10b981", marginBottom: 10 }}>
              ✅ Signed Claim Form Uploaded
            </div>
            {typeof signedUrl === "string" && (
              <a
                href={signedUrl}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  padding: "8px 14px", borderRadius: 10,
                  fontSize: 12, fontWeight: 700, textDecoration: "none",
                  background: isDark ? "rgba(99,102,241,0.12)" : "rgba(99,102,241,0.08)",
                  color: "#6366f1", border: "1.5px solid rgba(99,102,241,0.25)",
                }}
              >
                🔗 View Signed Form
              </a>
            )}
          </div>
        )}
          <>
            {/* 🔥 INSTRUCTION */}
            {!uploaded && (
            <div
              style={{
                marginBottom: 16,
                fontSize: 14,
                lineHeight: 1.6,
                opacity: 0.85,
              }}
            >
              📄 Download this form, read it carefully, fill the details,
              sign wherever required, and upload it again.
            </div>
            )}

            {/* DOWNLOAD BUTTON */}
            {downloadUrl ? (
              <a
                href={downloadUrl}
                target="_blank"
                rel="noreferrer"
                download
                style={{
                  display: "inline-block",
                  marginBottom: 16,
                  padding: "10px 18px",
                  borderRadius: 10,
                  textDecoration: "none",
                  fontWeight: 600,
                  fontSize: 13,
                  color: "#fff",
                  background: "linear-gradient(90deg,#6366f1,#8b5cf6,#ec4899)",
                  alignSelf: "flex-start",
                  boxShadow: "0 4px 14px rgba(99,102,241,0.25)",
                }}
              >
                ⬇ Download Claim Form
              </a>
            ) : (
              <div
                style={{
                  marginBottom: 16,
                  padding: "10px 14px",
                  borderRadius: 10,
                  fontSize: 13,
                  opacity: 0.6,
                  border: isDark
                    ? "1px dashed rgba(255,255,255,0.2)"
                    : "1px dashed rgba(99,102,241,0.3)",
                }}
              >
                ⏳ Claim form not yet uploaded by admin
              </div>
            )}

            {/* ERROR */}
            {error && (
              <div
                style={{
                  marginBottom: 12,
                  padding: "10px 14px",
                  borderRadius: 10,
                  fontSize: 13,
                  color: "#ef4444",
                  background: isDark
                    ? "rgba(239,68,68,0.12)"
                    : "rgba(239,68,68,0.08)",
                  border: "1px solid rgba(239,68,68,0.3)",
                }}
              >
                ⚠ {error}
              </div>
            )}

            {/* UPLOAD */}
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => { setFile(e.target.files[0]); setError(null); }}
              style={{
                marginBottom: 16,
                width: "100%",
                padding: 10,
                borderRadius: 10,
                border: isDark
                  ? "1px solid rgba(255,255,255,0.15)"
                  : "1px solid rgba(99,102,241,0.2)",
                background: isDark ? "#0b1220" : "#fff",
              }}
            />

            {/* SUBMIT */}
            <button
              onClick={handleUpload}
              disabled={loading}
              style={{
  padding: "10px 18px",
  borderRadius: 10,
  border: "none",
  fontSize: 13,
  fontWeight: 600,
  color: "#fff",
  cursor: loading ? "not-allowed" : "pointer",
  opacity: loading ? 0.7 : 1,
  background: "linear-gradient(90deg,#6366f1,#8b5cf6,#ec4899)",
  alignSelf: "flex-start",
  boxShadow: "0 4px 14px rgba(99,102,241,0.25)",
}}
            >
              {loading ? "Uploading…" : "Upload Filled Form"}
            </button>
          </>
      </div>
    </div>
  );
};

export default ClaimForm;